export default function notEmpty(value) {
    return value != null && value !== '';
}
